module.exports = __webpack_public_path__ + "img/teacher-nv.905f5644.png";